import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import asyncAction from 'modules/core/lib/asyncAction'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  onClose: () => void
  employee: Employee
}

const UninviteModal = ({ onClose, employee }: Props) => {
  const onSubmit = async () => {
    const { success, value } = await asyncAction(() => employeeUser(employee).rpc('uninvite'))

    if (success) employeeUser(employee).set(value)

    onClose()
  }

  return (
    <Modal
      title={i18n.t('employees.uninvite.action')}
      description={i18n.t('employees.uninvite.action_description')}
      illustration="single-neutral-actions"
      onSubmit={onSubmit}
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>{i18n.t('employees.uninvite.action')}</Button>
        </>
      }
    />
  )
}

export default UninviteModal
